import service from "./https"; // 路由配置

// url的链接
class API {
    // 上传
    image() {
        return "image";
    }
    upload() {
        return "upload";
    }

    // 注册
    postRegister(data:any) {
        return service.post("register", data);
    }
    putReset(data:any) {
        return service.put("reset", data);
    }
    getVerify(phone: string) {
        return service.get(`register/verify?phone=${encodeURIComponent(phone)}`);
    }
    // 用户登录
    login(userName: string, password: string) {
        return service.get(`login?userName=${encodeURIComponent(userName)}&password=${encodeURIComponent(password)}`);
    }

    // 获取机构树
    getAllUnitTree() {
        return service.get("unit/all");
    }
    getMyUnitTree() {
        return service.get("unit");
    }
    getUnitTree(id: number) {
        return service.get(`unit/${id}`);
    }
    getUnitsByParent(id: number, pageIndex: number, pageSize: number) {
        return service.get(`unit/${id}/children?pageIndex=${pageIndex}&pageSize=${pageSize}`);
    }
    postUnit(data: object) {
        return service.post("unit", data);
    }
    putUnit(data: object) {
        return service.put("unit", data);
    }
    delUnits(data: object) {
        return service.delete("unit", data);
    }


    // 获取用户列表
    getUsersByUnit(id: number, hasChildren: boolean, search: string, pageIndex: number, pageSize: number) {
        return service.get(`user?unitId=${id}&hasChildren=${hasChildren}&search=${encodeURIComponent(search)}&pageIndex=${pageIndex}&pageSize=${pageSize}`);
    }
    getUsersNeedAudit(pageIndex: number, pageSize: number) {
        return service.get(`user/audit?pageIndex=${pageIndex}&pageSize=${pageSize}`);
    }
    postUser(data: object) {
        return service.post("user", data);
    }
    putUser(data: object) {
        return service.put("user", data);
    }
    putUserAudit(data: object) {
        return service.put("user/audit", data);
    }
    putUserPassword(id: number) {
        return service.put(`user/${id}/password`);
    }
    putUserInfo(data: object) {
        return service.put("user/info", data);
    }
    putUserTransfer(unitId: number, data: object) {
        return service.put(`user/transfer?unitId=${unitId}`, data);
    }
    delUsers(data: object) {
        return service.delete("user", data);
    }
    putUserTransfer2(unitId: number) {
        return service.put(`user/transfer/${unitId}`);
    }


    // 获取题库
    getLibraries(pageIndex: number, pageSize: number) {
        return service.get(`library?pageIndex=${pageIndex}&pageSize=${pageSize}`);
    }
    getMyLibraries(pageIndex: number, pageSize: number) {
        return service.get(`library/my?pageIndex=${pageIndex}&pageSize=${pageSize}`);
    }
    postLibrary(data: object) {
        return service.post("library", data);
    }
    putLibrary(data: object) {
        return service.put("library", data);
    }
    delLibraries(data: object) {
        return service.delete("library", data);
    }
    getLibraryXML(id: number) {
        return service.get(`library/${id}/xml`);
    }


    // 获取章节
    getChapters(libraryId: number) {
        return service.get(`chapter?libraryId=${libraryId}`);
    }
    postChapter(data: object) {
        return service.post("chapter", data);
    }
    putChapter(data: object) {
        return service.put("chapter", data);
    }
    delChapters(libraryId: number, data: object) {
        return service.delete(`chapter?libraryId=${libraryId}`, data);
    }

    // 获取试题
    getTopics(libraryId: number | null, chapterId: number | null) {
        if (chapterId)
            return service.get(`topic?chapterId=${chapterId}`);
        else
            return service.get(`topic?libraryId=${libraryId}`);
    }

    // 获取试题
    getPractice(libraryId: number | null, chapterId: number | null) {
        if (chapterId)
            return service.get(`topic/practice?chapterId=${chapterId}`);
        else
            return service.get(`topic/practice?libraryId=${libraryId}`);
    }
    postPractice(libraryId: number | null, chapterId: number | null, data: object) {
        if (chapterId)
            return service.post(`topic/practice?chapterId=${chapterId}`, data);
        else
            return service.post(`topic/practice?libraryId=${libraryId}`, data);
    }

    // 收藏
    getFavorites(libraryId: number | null, chapterId: number | null) {
        if (chapterId)
            return service.get(`favorite?chapterId=${chapterId}`);
        else
            return service.get(`favorite?libraryId=${libraryId}`);
    }
    postFavorites(libraryId: number, chapterId: number | null, data: object) {
        if (chapterId)
            return service.post(`favorite?libraryId=${libraryId}&chapterId=${chapterId}`, data);
        else
            return service.post(`favorite?libraryId=${libraryId}`, data);
    }

    // 模拟测试
    postMock(libraryId: number | null, chapterId: number | null, data: object) {
        if (chapterId)
            return service.post(`mock?chapterId=${chapterId}`, data);
        else
            return service.post(`mock?libraryId=${libraryId}`, data);
    }
    // 模拟测试
    putMockResult(mockId: number, data: object) {
        return service.put(`mock/${mockId}`, data);
    }


    // 获取正式考试
    getFormals(hasChildren:boolean, pageIndex: number, pageSize: number) {
        return service.get(`formal?hasChildren=${hasChildren}&pageIndex=${pageIndex}&pageSize=${pageSize}`);
    }
    getMyFormals() {
        return service.get("formal/my");
    }
    getFormalExport(formalId: number) {
        return service.get(`formal/${formalId}/export`, { responseType: 'blob' });
    }
    getFormalRecord(userId : number, formalId: number) {
        return service.get(`formal/${formalId}/record/${userId}`);
    }
    getFormalRecords(formalId: number, unitId: number | null, nickName: string | null, pageIndex: number, pageSize: number) {
        if (unitId)
            return service.get(`formal/${formalId}/record?pageIndex=${pageIndex}&pageSize=${pageSize}&unitId=${unitId}`);
        else if (typeof nickName != "undefined" && nickName != null && nickName != "")
            return service.get(`formal/${formalId}/record?pageIndex=${pageIndex}&pageSize=${pageSize}&nickName=${encodeURIComponent(nickName)}`);
        else
            return service.get(`formal/${formalId}/record?pageIndex=${pageIndex}&pageSize=${pageSize}`);
    }
    getMyFormalRecords(pageIndex: number, pageSize: number) {
        return service.get(`record?pageIndex=${pageIndex}&pageSize=${pageSize}`);
    }
    getMyFormalAnswer(formalId: number) {
        return service.get(`formal/${formalId}/answer`);
    }
    postFormal(data: object) {
        return service.post("formal", data);
    }
    postFormal2(formalId: number, machineId: string, data: object) {
        return service.post(`formal/${formalId}?machineId=${machineId}`, data);
    }
    putFormal(data: object) {
        return service.put("formal", data);
    }
    putFormal2(formalId: number, machineId: string, data: object) {
        return service.put(`formal/${formalId}?machineId=${machineId}`, data);
    }
    delFormals(data: object) {
        return service.delete("formal", data);
    }
    delFormalRecords(formalId: number, data: object) {
        return service.delete(`formal/${formalId}/record`, data);
    }

    // 获取栏目
    getCategories(pageIndex: number, pageSize: number) {
        return service.get(`category?pageIndex=${pageIndex}&pageSize=${pageSize}`);
    }
    getMyCategories() {
        return service.get("category/my");
    }
    postCategory(data: object) {
        return service.post("category", data);
    }
    putCategory(data: object) {
        return service.put("category", data);
    }
    delCategories(data: object) {
        return service.delete("category", data);
    }

    // 获取文章
    getArticles(categoryId: number | null, pageIndex: number, pageSize: number) {
        if (categoryId)
            return service.get(`article?categoryId=${categoryId}&pageIndex=${pageIndex}&pageSize=${pageSize}`);
        else
            return service.get(`article?pageIndex=${pageIndex}&pageSize=${pageSize}`);
    }
    getArticleDetail(articleId: number) {
        return service.get(`article/${articleId}`);
    }
    postArticle(data: object) {
        return service.post("article", data);
    }
    putArticle(data: object) {
        return service.put("article", data);
    }
    delArticles(data: object) {
        return service.delete("article", data);
    }

    // 获取附件
    getFiles(articleId: number) {
        return service.get(`file?articleId=${articleId}`);
    }
    postFile(articleId: number, data: object) {
        return service.post(`file?articleId=${articleId}`, data,
            {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });
    }
    delFiles(articleId: number, data: object) {
        return service.delete(`file?articleId=${articleId}`, data);
    }

    joinQueryString(url: string, search: any): string {
        if (search) {
            for (const key in search) {
                // 过滤undefined和null和空字符串
                const value = search[key];
                switch (typeof (value)) {
                    case "undefined":
                    case "function":
                    case "object":
                        break;
                    case "string":
                        if (value !== "")
                            url += '&' + key + '=' + encodeURIComponent(search[key]);
                        break;
                    default:
                        url += '&' + key + '=' + search[key];
                        break;
                }
            }
        }
        return url;
    }
}

export const apis = new API();
export default apis;